import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

interface StatusBadgeProps {
  status: string;
  whatsapp: boolean;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, whatsapp }) => {
  const { t } = useTranslation();
  
  const getStatusColor = () => {
    switch (status) {
      case 'Validado':
        return { bg: 'bg-green-100 dark:bg-green-900/50', text: 'text-green-700 dark:text-green-300', dot: 'bg-green-500', display: t('dashboard.status_validated') };
      case 'Pendente':
        return { bg: 'bg-yellow-100 dark:bg-yellow-900/50', text: 'text-yellow-800 dark:text-yellow-300', dot: 'bg-yellow-500', display: t('dashboard.status_pending') };
      case 'Inválido':
        return { bg: 'bg-red-100 dark:bg-red-900/50', text: 'text-red-700 dark:text-red-300', dot: 'bg-red-500', display: t('dashboard.status_invalid') };
      default:
        return { bg: 'bg-gray-100 dark:bg-gray-900/50', text: 'text-gray-700 dark:text-gray-300', dot: 'bg-gray-500', display: status };
    }
  };

  const colors = getStatusColor();

  return (
    <motion.span
      className={`inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium ${colors.bg} ${colors.text}`}
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ type: "spring", stiffness: 500, damping: 30 }}
    >
      <motion.span
        className={`size-1.5 rounded-full ${colors.dot}`}
        animate={{ scale: [1, 1.2, 1] }}
        transition={{ duration: 2, repeat: Infinity }}
      />
      {colors.display}
    </motion.span>
  );
};

export default StatusBadge;